import { Box, Button } from "@mui/material";
import classes from "./FilterItem.module.scss";

export default function FilterItem({
  name,
  disabled = false,
  onClose,
}: {
  name: string;
  disabled?: boolean;
  onClose?: () => void;
}) {
  return (
    <Box
      className={`${classes.filterChip} ${disabled ? classes.disabled : ""}`}
    >
      {name}
      {onClose && (
        <Button
          className={classes.close}
          onClick={onClose}
          disableRipple
          disabled={disabled}
        >
          ✕
        </Button>
      )}
    </Box>
  );
}
